import Vue from "vue";
import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GOOGLE_ADS_ID },
  includes: [{
    id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID
  }]
});
